import { Action as ReduxAction, AnyAction as ReduxAnyAction } from 'redux';
import { ThunkAction as ReduxThunkAction, ThunkDispatch } from 'redux-thunk';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import Immutable from '../utils/immutable-type';

export type RootState = Immutable<{ [sliceName: string]: unknown }>;
export type AppAction<Actions extends ReduxAction = ReduxAnyAction> = Actions;

export type ThunkAction<
	Actions extends ReduxAction = AppAction,
	ReturnType = void,
	ExtraArgs = unknown
> = ReduxThunkAction<ReturnType, RootState, ExtraArgs, Actions>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AppDispatch = ThunkDispatch<RootState, any, AppAction>;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
